"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6206],{

/***/ 47221:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s$": () => (/* reexport */ getOrderDetails)
});

// UNUSED EXPORTS: getCommonLandingPageDetails, getCommonsHeaderData, getLandingPageDetails, getMyPartnerMockListing, getNextPageRouteDetails, getOrderConfirmedDetails, getOrderDetailsV2, getOrderListing, getPassportDetails, getPolicyStatus, getProductListing, getSeoLandingPageDetailsByCountry, getSeoLandingPageDetailsByCountryForPwa, getTravelAttributes

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/api-utils/src/index.ts + 6 modules
var src = __webpack_require__(91973);
// EXTERNAL MODULE: ../../node_modules/axios/index.js
var node_modules_axios = __webpack_require__(89644);
var axios_default = /*#__PURE__*/__webpack_require__.n(node_modules_axios);
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiInstance/index.ts


const AXIOS_HTTP_CONFIG = {
  baseURL: src/* API_BASE_URL_HTTP */.SW,
  timeout: src/* API_TIMEOUT_IN_MS */.Sb,
  withCredentials: true,
  retry: 1
};

if (false) {}

const apiInstance_API_HTTP = axios_default().create(AXIOS_HTTP_CONFIG);
apiInstance_API_HTTP.interceptors.request.use(function (config) {
  config.headers = src/* interceptors.enhanceRequestHeaders */.JQ.enhanceRequestHeaders(config.headers);
  return config;
});

if (false) {}

apiInstance_API_HTTP.interceptors.response.use(response => {
  return response;
}, async error => {
  return src/* interceptors.retryAxiosRequest */.JQ.retryAxiosRequest(error, apiInstance_API_HTTP);
});
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/setURLQueryParams/index.ts
const setURLQueryParams_setURLQueryParams = (params = {}) => {
  const usp = new URLSearchParams();
  Object.keys(params).forEach(e => {
    if (params[e]) {
      usp.set(e, params[e].toString());
    }
  });
  return usp.toString();
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getCommonLandingPageDetails.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const getCommonLandingPageDetails = async reqData => {
  const {
    partner,
    headers,
    cmp,
    query,
    dvid
  } = reqData;

  const params = _objectSpread({
    lob: "standalone",
    authV2: "true"
  }, query);

  const urlParams = setURLQueryParams(params);
  const response = await API_HTTP.get(`${API_ROUTE_V2_PREFIX}/${partner}/${API_ROUTES.GET_ENTRYPOINT_LANDING_PAGE_DATA}${urlParams ? `?${urlParams}` : ""}`, {
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      cmp: cmp || "fallback",
      dvid
    })
  });
  return response;
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getCommonsHeaderData.ts



const getCommonsHeaderData = async (dvid = "", profile = "PERSONAL", auth = "") => {
  const params = {
    region: "in",
    currency: "inr",
    "user-currency": "INR",
    language: "eng"
  };
  const headers = {
    "Content-Type": "application/json",
    authorization: "h4nhc9jcgpAGIjp",
    currency: "inr",
    deviceid: dvid,
    "entity-name": "india",
    language: "eng",
    "mmt-auth": auth,
    pfm: "desktop",
    profile: profile,
    region: "in",
    "user-currency": "INR"
  };
  const urlParams = setURLQueryParams(params);
  const url = `${API_BASE_URL_HTTP_COMMONS_CB}${API_ROUTE_PREFIX_COMMONS_CB}/${API_ROUTES.GET_COMMONS_HEADER_DATA}${urlParams ? `?${urlParams}` : ""}`;

  try {
    const response = await axios.get(url, {
      headers
    });
    return response.data;
  } catch (error) {
    console.log("Common Header Server Side Error ------->", error);
    return null;
  }
};
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var isomorphic_utils_src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/server-utils/src/index.ts + 5 modules
var server_utils_src = __webpack_require__(2349);
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getLandingPageDetails.ts


function getLandingPageDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getLandingPageDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getLandingPageDetails_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getLandingPageDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const getLandingPageDetails = async reqData => {
  const {
    partner,
    headers,
    cmp,
    query,
    dvid
  } = reqData;
  const {
    type
  } = query || {};

  const params = getLandingPageDetails_objectSpread({
    lob: getLobOnServerSide(partner) || LOB.STANDALONE
  }, query);

  const urlParams = setURLQueryParams(params);

  if (type) {
    const response = await API_HTTP.get(`${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_GENERIC_PATH}/${type}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getLandingPageDetails_objectSpread(getLandingPageDetails_objectSpread({}, headers), {}, {
        cmp,
        dvid
      })
    });
    return response;
  } else if (partner === PARTNER.MYPARTNER) {
    const response = await API_HTTP.get(`${API_ROUTE_PREFIX}/${API_ROUTES.GET_LANDING_PAGE_DETAILS_MY_PARTNER}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getLandingPageDetails_objectSpread(getLandingPageDetails_objectSpread({}, headers), {}, {
        cmp,
        dvid
      })
    });
    return response;
  } else if (partner === PARTNER.MYBIZ) {
    const response = await API_HTTP.get(`${API_ROUTE_V2_PREFIX}/mmt/${API_ROUTES.GET_LANDING_PAGE_DETAILS}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getLandingPageDetails_objectSpread(getLandingPageDetails_objectSpread({}, headers), {}, {
        cmp: cmp || "fallback",
        dvid
      })
    });
    return response;
  } else {
    const response = await API_HTTP.get(`${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_LANDING_PAGE_DETAILS}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getLandingPageDetails_objectSpread(getLandingPageDetails_objectSpread({}, headers), {}, {
        cmp: cmp || query?.["cmp"] || "fallback",
        dvid
      })
    });
    return response;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/mocks/my-partner-listing-mock.json
const my_partner_listing_mock_namespaceObject = {};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getMyPartnerMockListing.ts

/**
 * Mock API response for MyPartner product listing
 * Returns a pre-defined response structure for testing/development purposes
 * Data is hardcoded to avoid external API dependency
 */

const getMyPartnerMockListing_getMyPartnerMockListing = async reqData => {
  return Promise.resolve({
    data: mockData
  });
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getNextPageRouteDetails.ts


function getNextPageRouteDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getNextPageRouteDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getNextPageRouteDetails_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getNextPageRouteDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const getNextPageRouteDetails = async reqData => {
  try {
    const {
      partner = PARTNER.MMT,
      headers,
      cmp,
      query,
      userSearchIntent,
      dvid,
      lob
    } = reqData;

    const params = getNextPageRouteDetails_objectSpread({
      lob: lob || LOB.STANDALONE,
      platform: PLATFORM.WEB,
      context: CONTEXT.STANDALONE_V2,
      isCountryCodesSupported: true.toString(),
      partner
    }, query);

    const urlParams = setURLQueryParams(params);
    let url;

    if (partner === PARTNER.MYPARTNER) {
      url = `${API_ROUTE_PREFIX}/${API_ROUTES.GET_NEXT_PAGE_ROUTE_MYPARTNER}${urlParams ? `?${urlParams}` : ""}`;
    } else {
      url = `${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_NEXT_PAGE_ROUTE}${urlParams ? `?${urlParams}` : ""}`;
    }

    const response = await API_HTTP.post(url, {
      userSearchIntent
    }, {
      headers: getNextPageRouteDetails_objectSpread(getNextPageRouteDetails_objectSpread({}, headers), {}, {
        cmp: cmp || query?.["cmp"] || "fallback",
        dvid
      })
    });
    return getNextPageRouteDetails_objectSpread(getNextPageRouteDetails_objectSpread({}, response), {}, {
      isNextPageCall: true
    });
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getOrderConfirmedDetails.ts


function getOrderConfirmedDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getOrderConfirmedDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getOrderConfirmedDetails_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getOrderConfirmedDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const getOrderConfirmedDetails = async data => {
  const {
    partner,
    bookingId,
    headers,
    cmp,
    query,
    dvid,
    itineraryId
  } = data;

  try {
    const params = getOrderConfirmedDetails_objectSpread({
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      tmBookingId: bookingId,
      itineraryId: itineraryId || ""
    }, query);

    const urlParams = setURLQueryParams(params);
    const httpRoutePrefix = getHTTPRoutePrefix(partner);
    const pathPartner = getPathPartnerOnServerSide(partner);
    const response = await API_HTTP.get(`${httpRoutePrefix}/${pathPartner}/${API_ROUTES.ORDER_CONFIRMED}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getOrderConfirmedDetails_objectSpread(getOrderConfirmedDetails_objectSpread({}, headers), {}, {
        cmp:  true && sessionStorage.getItem("cmp") || cmp || "fallback_thanksyou",
        dvid
      })
    });
    return response;
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getOrderDetails.ts


function getOrderDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getOrderDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getOrderDetails_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getOrderDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const getOrderDetails = async data => {
  try {
    const {
      partner,
      bookingId,
      headers,
      cmp,
      query,
      dvid
    } = data || {};

    const params = getOrderDetails_objectSpread({
      lob: (0,server_utils_src/* getLobOnServerSide */.mJ)(partner) || isomorphic_utils_src.LOB.STANDALONE,
      bookingId
    }, query);

    const urlParams = setURLQueryParams_setURLQueryParams(params);
    const response = await apiInstance_API_HTTP.get(`${src/* API_ROUTE_PREFIX */.XO}/${partner}/${src/* API_ROUTES.ORDER_DETAIL */.qf.ORDER_DETAIL}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getOrderDetails_objectSpread(getOrderDetails_objectSpread({}, headers), {}, {
        cmp: cmp || query?.["cmp"] || "fallback",
        dvid
      })
    });
    return response;
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getOrderDetailsV2.ts


function getOrderDetailsV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getOrderDetailsV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getOrderDetailsV2_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getOrderDetailsV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const getOrderDetailsV2 = async data => {
  try {
    const {
      partner,
      bookingId,
      headers,
      cmp,
      query,
      dvid
    } = data || {};

    const params = getOrderDetailsV2_objectSpread({
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId
    }, query);

    const urlParams = setURLQueryParams(params);
    const response = await API_HTTP.get(`${API_ROUTE_V2_PREFIX_HTTPS}/${partner}/${API_ROUTES.ORDER_DETAIL}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getOrderDetailsV2_objectSpread(getOrderDetailsV2_objectSpread({}, headers), {}, {
        cmp,
        dvid
      })
    });
    return response;
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getOrderListing.ts


function getOrderListing_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getOrderListing_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getOrderListing_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getOrderListing_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const getOrderListing = async reqData => {
  try {
    const {
      partner = PARTNER.MMT,
      headers,
      cmp,
      query,
      dvid
    } = reqData;

    const params = getOrderListing_objectSpread({
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      context: CONTEXT.STANDALONE_V2,
      ins_new_flow: true
    }, query);

    const urlParams = setURLQueryParams(params);
    const pathPartner = getPathPartnerOnServerSide(partner);
    const response = await API_HTTP.get(`${API_ROUTE_PREFIX}/${pathPartner}/${API_ROUTES.ORDER_LISTING}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getOrderListing_objectSpread(getOrderListing_objectSpread({}, headers), {}, {
        cmp: cmp || query?.["cmp"] || "fallback",
        dvid
      })
    });
    return response;
  } catch (error) {
    console.error("Error", {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getPassportDetails.ts


function getPassportDetails_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getPassportDetails_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getPassportDetails_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getPassportDetails_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





const getPassportDetails = async reqData => {
  try {
    const {
      bookingId,
      pageId,
      partner = PARTNER.MMT,
      headers,
      cmp,
      query,
      dvid
    } = reqData;

    const params = getPassportDetails_objectSpread({
      bookingId,
      pageId
    }, query);

    const urlParams = setURLQueryParams(params);
    const response = await API_HTTP.get(`${API_ROUTE_PREFIX}/${partner}/${API_ROUTES.GET_PASSPORT_DETAILS}${urlParams ? `?${urlParams}` : ""}`, {
      headers: getPassportDetails_objectSpread(getPassportDetails_objectSpread({}, headers), {}, {
        cmp,
        dvid
      })
    });
    return response;
  } catch (error) {
    console.log("Error", {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getPolicyStatus.ts


function getPolicyStatus_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getPolicyStatus_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getPolicyStatus_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getPolicyStatus_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






/**
 * TEMP API - Temporary endpoint for polling policy status
 * TODO: Replace with actual API endpoint when available
 */

const getPolicyStatus = async data => {
  try {
    const {
      partner,
      bookingId,
      headers,
      cmp,
      query,
      dvid
    } = data || {};

    const params = getPolicyStatus_objectSpread({
      lob: getLobOnServerSide(partner) || LOB.STANDALONE,
      bookingId
    }, query);

    const urlParams = setURLQueryParams(params); // TEMP: Using a temporary endpoint - replace with actual endpoint

    const response = await API_HTTP.get(`${API_ROUTE_V2_PREFIX}/${partner}/insurance/cb/policyStatus${urlParams ? `?${urlParams}` : ""}`, {
      headers: getPolicyStatus_objectSpread(getPolicyStatus_objectSpread({}, headers), {}, {
        cmp,
        dvid
      })
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching policy status", {
      error
    });
    throw error;
  }
};
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getProductListing.ts
/* provided dependency */ var process = __webpack_require__(34406);


const _excluded = (/* unused pure expression or super */ null && (["headers", "cmp", "query", "dvid"]));

function getProductListing_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getProductListing_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getProductListing_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getProductListing_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







const getProductListing = async reqData => {
  let {
    partner = PARTNER.MMT
  } = reqData;

  const {
    headers,
    cmp,
    query,
    dvid
  } = reqData,
        data = _objectWithoutProperties(reqData, _excluded); // Check for MOCK_CLIENT_PARTNER environment variable first
  //TODO: CLEANUP: Remove mock client partner and also libs/server-api-utils/src/apiRoutes/mocks post mybiz merge to release


  if (process.env["MOCK_CLIENT_PARTNER"]) {
    const mockPartner = process.env["MOCK_CLIENT_PARTNER"]; // Validate that the mock partner is a valid partner value

    const validPartners = Object.values(PARTNER);

    if (validPartners.includes(mockPartner)) {
      partner = mockPartner;
    }

    return getMyPartnerMockListing(reqData);
  } // For other partners, use regular API call


  const params = getProductListing_objectSpread({
    lob: getLobOnServerSide(partner) || LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    isCountryCodesSupported: true,
    partner
  }, query);

  const urlParams = setURLQueryParams(params);
  const httpRoutePrefix = getHTTPRoutePrefix(partner);
  const pathPartner = getPathPartnerOnServerSide(partner);
  const response = await API_HTTP.post(`${httpRoutePrefix}/${pathPartner}/${API_ROUTES.GET_PRODUCT_LISTING}${urlParams ? `?${urlParams}` : ""}`, data, {
    headers: getProductListing_objectSpread(getProductListing_objectSpread({}, headers), {}, {
      cmp: cmp || query?.["cmp"] || "fallback",
      dvid
    })
  });
  return response;
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getSeoLandingPage.ts



const getSeoLandingPageDetailsByCountryForPwa = async (countryId, partner) => {
  try {
    const response = await fetch(`${CMS_API_BASE_URL}/api/v1/seo/jsons?type=${partner === PARTNER.GI ? SEO_PAGES_QUERY_ID.LANDING_PAGE_COUNTRY_GI : SEO_PAGES_QUERY_ID.LANDING_PAGE_COUNTRY},seo-insurance${partner === PARTNER.GI ? `-${partner}` : ""}-landing-${countryId}`);

    if (response.status !== 200) {
      throw new Error(`Error fetching data for SEO landing page for ${countryId}`);
    }

    const json = await response.json();
    return json;
  } catch (error) {
    console.error(`Error fetching data for SEO landing page for ${countryId}`, {
      error
    });
    throw error;
  }
};
const getSeoLandingPageDetailsByCountry = async (countryId, partner) => {
  try {
    const response = await API_HTTP.get(`${CMS_API_BASE_URL}/api/v1/seo/jsons?type=${partner === PARTNER.GI ? SEO_PAGES_V2_QUERY_ID.LANDING_PAGE_COUNTRY_GI : SEO_PAGES_V2_QUERY_ID.LANDING_PAGE_COUNTRY},seo-insurance${partner === PARTNER.GI ? `-${partner}` : ""}-landing-${countryId}`);
    return response?.data;
  } catch (error) {
    console.error(`Error fetching data for SEO landing page for ${countryId}`, {
      error
    });
    throw error;
  }
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/getTravelAttributes.ts


const getTravelAttributes_excluded = (/* unused pure expression or super */ null && (["isUpcomingTrip", "bookingId", "countries", "startDate", "endDate", "travellers"]));

function getTravelAttributes_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function getTravelAttributes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? getTravelAttributes_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : getTravelAttributes_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






const getTravelAttributes = async reqData => {
  const {
    partner = PARTNER.MMT,
    headers,
    cmp,
    query,
    dvid
  } = reqData || {};

  const _ref = query || {},
        {
    isUpcomingTrip,
    bookingId,
    countries,
    startDate,
    endDate,
    travellers
  } = _ref,
        queryParams = _objectWithoutProperties(_ref, getTravelAttributes_excluded);

  const params = getTravelAttributes_objectSpread(getTravelAttributes_objectSpread(getTravelAttributes_objectSpread(getTravelAttributes_objectSpread(getTravelAttributes_objectSpread(getTravelAttributes_objectSpread(getTravelAttributes_objectSpread({
    lob: getLobOnServerSide(partner) || LOB.STANDALONE,
    platform: PLATFORM.WEB,
    context: CONTEXT.STANDALONE_V2,
    travelPurpose: "Leisure Trip"
  }, isUpcomingTrip && {
    upcomingTraveller: isUpcomingTrip === "true" ? true : false
  }), bookingId && {
    booking_id: bookingId.toString()
  }), countries && {
    countryCodes: countries.toString()
  }), startDate && {
    departureDateTime: Number(startDate)
  }), endDate && {
    arrivalDateTime: Number(endDate)
  }), travellers && {
    numberOfTravellers: Number(travellers)
  }), queryParams);

  const urlParams = setURLQueryParams(params);
  const httpRoutePrefix = getHTTPRoutePrefix(partner);
  const pathPartner = getPathPartnerOnServerSide(partner);
  const url = `${httpRoutePrefix}/${pathPartner}/${API_ROUTES.GET_TRAVEL_ATTRIBUTES}${urlParams ? `?${urlParams}` : ""}`;
  const response = await API_HTTP.get(url, {
    headers: getTravelAttributes_objectSpread(getTravelAttributes_objectSpread({}, headers), {}, {
      cmp: cmp || "fallback",
      dvid
    })
  });
  return response;
};
;// CONCATENATED MODULE: ../../libs/server-api-utils/src/apiRoutes/index.ts
// @TODO, create a mapping for API URLs based on partner and page














;// CONCATENATED MODULE: ../../libs/server-api-utils/src/index.ts


/***/ })

}]);